import type { ReadonlyDeep } from 'type-fest';

import { MaterialUsageInput, QuantityInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';

import type { MaterialUsageForm_MaterialUsage } from '../fragments/material-usage.fragment.tsx';

export function materialUsageForm2ApiMapper(
  materialUsage: ReadonlyDeep<MaterialUsageForm_MaterialUsage>,
): ReadonlyDeep<MaterialUsageInput> {
  const materialUsageInput = pruneInput(materialUsage, MaterialUsageInput);

  return {
    ...materialUsageInput,
    quantity: pruneInput(materialUsageInput.quantity, QuantityInput),
  };
}
